'use client'

import {usePlayButton} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {useEffect} from 'react'
import {focusGameIframe, unmuteGame} from '../game-functions'
import {playBtnId} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-client'

type Props = {
  gameCode: string
  gameNameEn: string
}

const StartGameOnKeyUpClient = ({gameNameEn, gameCode}: Props) => {
  const {gameScreenShown, showGameScreen} = usePlayButton()
  const handleGameStart = () => {
    showGameScreen()
    focusGameIframe()
    triggerAnalytics('game-play-button-clicked', {
      'game-name': gameNameEn,
      'game-code': gameCode,
    }).sendAll()
    unmuteGame()
  }

  useEffect(() => {
    if (gameScreenShown) return

    const onKeyUp = (e: KeyboardEvent) => {
      const activeElement = document.activeElement
      const isBodyFocused = activeElement === document.body
      const isNoFocus = activeElement === null
      const isTargetPlayBtn = (e.target as HTMLElement)?.id === playBtnId

      if (e.key === 'Enter' && (isTargetPlayBtn || isBodyFocused || isNoFocus)) {
        handleGameStart()
        document.removeEventListener('keyup', onKeyUp)
      }
    }

    document.addEventListener('keyup', onKeyUp)
    return () => document.removeEventListener('keyup', onKeyUp)
  }, [gameScreenShown, showGameScreen])

  return null
}

export default StartGameOnKeyUpClient
